
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";

interface PricingOption {
  title: string;
  price: string;
  features: string[];
  ctaText: string;
  ctaLink: string;
}

const pricingOptions: PricingOption[] = [
  {
    title: "1-Hour Rental",
    price: "$100",
    features: [
      "1-3 Person Setup",
      "Our software live-edits as you record.",
      "Audio, video and lighting gear included. 2x microphones. 3x Cameras.",
      "Raw audio/video files.",
      "Uploaded to personal shared google drive folder."
    ],
    ctaText: "Book Here",
    ctaLink: "https://savvycal.com/atxstudio/1hour"
  },
  {
    title: "2-Hour Rental",
    price: "$200",
    features: [
      "1-3 Person Setup",
      "Our software live-edits as you record.",
      "Audio, video and lighting gear included. 2x microphones. 3x Cameras.",
      "Raw audio/video files.",
      "Uploaded to personal shared google drive folder."
    ],
    ctaText: "Book Here",
    ctaLink: "https://savvycal.com/atxstudio/2hour"
  },
  {
    title: "Editing Service",
    price: "$75 /episode",
    features: [
      "Professional editing for best visual and audio experience",
      "Studio Editing Quality",
      "Removes filler words & errors",
      "Get 3 professional 60-90 second shorts for TikTok, YouTube & Instagram!",
      "Add any-time after a recording!"
    ],
    ctaText: "Book Here",
    ctaLink: "https://buy.stripe.com/aEU002eAR10f6nm28d"
  }
];

export function PricingComparison() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-studio-stone mb-4">What it Costs</h2>
          <p className="text-xl text-studio-stone/80">
            Choose your recording adventure: 1 or 2 hours. Need editing? We'll make you sound like you know what you're doing, even if you don't.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {pricingOptions.map((option, index) => (
            <Card key={index} className="p-6 flex flex-col bg-white hover:shadow-lg transition-shadow">
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-studio-stone mb-4">{option.title}</h3>
                <div className="text-3xl font-bold text-studio-sage mb-6">{option.price}</div>
                <ul className="space-y-4">
                  {option.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start gap-2">
                      <Check className="w-5 h-5 text-studio-sage mt-1 flex-shrink-0" />
                      <span className="text-studio-stone/80">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="mt-auto">
                <Button 
                  className="w-full bg-studio-sage hover:bg-studio-sage/90 text-white"
                  onClick={() => window.location.href = option.ctaLink}
                >
                  {option.ctaText}
                </Button>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
